import { ConfigProvider } from "antd";
import { bgColors } from "@/styles/theme";
import { inter } from "@/pages/_app";

type Props = {
  children: React.ReactNode;
};

// Use CSS variable for font family - already loaded in _app.tsx
// This avoids duplicate font loading and reduces bundle size
const AntdConfig = ({ children }: Props) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: bgColors.primary,
          // Use CSS variable instead of loading font again
          // fontFamily: "var(--font-inter), -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          fontFamily: inter.style.fontFamily,
          // MAIN BREAKPOINT VALUES
          screenXS: 0,
          screenSM: 768,
          screenMD: 1024,
          screenLG: 1440,
          screenXL: 1600,
          screenXXL: 1920,

          // MIN VALUES (must match)
          screenXSMin: 0,
          screenSMMin: 768,
          screenMDMin: 1024,
          screenLGMin: 1440,
          screenXLMin: 1600,
          screenXXLMin: 1920,

          // MAX VALUES (one less than next min)
          screenXSMax: 767,
          screenSMMax: 1023,
          screenMDMax: 1439,
          screenLGMax: 1599,
          screenXLMax: 1919,
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default AntdConfig;
